import { useQuickActionsMenuContext } from 'modules/quickActionsMenu/contexts';
import { useCount } from 'modules/quickActionsMenu/hooks';
import { SetCount } from 'modules/quickActionsMenu/types';
import { getJourneyStatus } from 'modules/quickActionsMenu/utils';
import { Fragment16 } from 'ui/icons/aurora/16px/studio';
import { Spinner } from 'ui/spinner';
import { Item } from '../Item';
import { StyledBadge } from '../Item/Item.styled';
import { CommandGroup, CommandLoading, EmptyState } from '../Styled';
import { useJourneySearch } from './useJourneySearch';

export const JOURNEY_SEARCH_TEXT = {
  heading: 'Journeys',
  emptyStateMessage: 'No matching results',
  zeroStateMessage: 'Type a journey’s name or ID to search',
};

const { emptyStateMessage, heading, zeroStateMessage } = JOURNEY_SEARCH_TEXT;

export const JourneySearch = ({ setCount }: { setCount: SetCount }) => {
  const { debouncedSearchTerm, navigate } = useQuickActionsMenuContext();
  const { info, journeys, isLoading } = useJourneySearch(debouncedSearchTerm);
  useCount({ count: info?.count, setCount });

  if (isLoading) {
    return (
      <CommandLoading>
        <Spinner />
      </CommandLoading>
    );
  }

  return (
    <>
      {!journeys?.length && (
        <EmptyState>
          {debouncedSearchTerm.length === 0 ? zeroStateMessage : emptyStateMessage}
        </EmptyState>
      )}

      {journeys.length > 0 && (
        <CommandGroup heading={heading}>
          {journeys.map((journey) => {
            const { id, name, workflowType } = journey;
            const { displayText, variant } = getJourneyStatus(journey);
            return (
              <Item
                Icon={<Fragment16 isColorInherited />}
                id={id}
                key={id}
                name={name}
                onSelect={() =>
                  navigate({
                    id,
                    pageName: 'Journey details page',
                    path: `/workflows/${id}/edit?mode=beta&workflowType=${workflowType}`,
                  })
                }
                suffix={<StyledBadge variant={variant}>{displayText}</StyledBadge>}
                value={`${name} ${id}`}
              />
            );
          })}
        </CommandGroup>
      )}
    </>
  );
};
